import { render } from "./ImageDropzone.vue?vue&type=template&id=4a10f308"
import script from "./ImageDropzone.vue?vue&type=script&lang=js"
export * from "./ImageDropzone.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/components/ImageDropzone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4a10f308"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4a10f308', __exports__)) {
    api.reload('4a10f308', __exports__)
  }
  
  module.hot.accept("./ImageDropzone.vue?vue&type=template&id=4a10f308", () => {
    api.rerender('4a10f308', render)
  })

}


export default __exports__